<template>
  <div class="d-none" aria-hidden="true" />
</template>

<script>
export default {
  name: 'LinhaAssistenteRedirect',
  mounted() {
    try {
      sessionStorage.setItem('openLinhaAssistenteKml', '1');
    } catch (e) {
      /* ignore */
    }
    this.$router.replace({ name: 'Linhas' });
  },
};
</script>
